import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaHeart } from 'react-icons/fa';
import { ProductContext } from '../../context/ProductContext';
import { CartContext } from '../../context/CartContext';
import './ProductGrid.css';

const ProductGrid = () => {
  const { products, loading } = useContext(ProductContext);
  const { addToCart } = useContext(CartContext);

  if (loading) {
    return <div className="product-grid-loading">Chargement...</div>;
  }

  const featuredProducts = products.slice(0, 6);

  return (
    <section className="product-grid-section">
      <div className="section-header">
        <h2 className="section-title">
          <FaStar /> Premium Collection
        </h2>
        <Link to="/shop" className="view-all-link">
          View All <span>→</span>
        </Link>
      </div>

      <div className="product-grid">
        {featuredProducts.map((product) => (
          <div key={product.id} className="product-card">
            <Link to={`/product/${product.id}`} className="product-link">
              <div className="product-image">
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="product-img"
                />
                {product.tag && <span className="product-tag">{product.tag}</span>}
                <button className="wishlist-btn" onClick={(e) => e.preventDefault()}>
                  <FaHeart />
                </button>
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-rating">
                  {'★'.repeat(Math.floor(product.rating))}
                  <span className="rating-count">({product.rating})</span>
                </div>
                <p className="product-price">{product.price}</p>
              </div>
            </Link>
            <button 
              className="add-to-cart-btn"
              onClick={() => addToCart(product)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductGrid;